import classNames from 'classnames';
import { ReportResponse, ReportStatus } from 'compliance-api';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import { mapReportTypeToName } from '@/modules/common/components/ReportTypeSelect.tsx';
import {
  useDeleteReportMutation,
  useRestoreReportMutation,
} from '@/modules/common/queries/reports.ts';
import ArchivedItemAction from '@/modules/admin-dashboard/components/ArchivedItemAction.tsx';
import { DisclosureListItem, Spinner, TooltipNew } from 'ui';
import { AlertOrangeIcon, DownloadGreyIcon, TrashGrayIcon } from 'ui/icons';
import { fixNameEnum } from 'ui/utils';

interface ReportItemProps {
  report: ReportResponse;
}

const ReportItem = ({ report }: ReportItemProps) => {
  const { id, name, created_at, type, format, url, deleted_at } = report;

  const { mutateAsync: deleteReport, isLoading: isReportDeletion } = useDeleteReportMutation();

  const handleDeleteReport = useCallback(
    (id: number) => {
      deleteReport(id);
    },
    [deleteReport],
  );
  return (
    <DisclosureListItem
      key={id}
      classes={{ container: classNames({ 'bg-gray-100': deleted_at }) }}
      leftMainString={name}
      leftSubduedContentSet={[
        dayjs(created_at).format('DD-MM-YYYY, HH:mm'),
        mapReportTypeToName[type] || fixNameEnum(type),
        format.toUpperCase(),
      ]}
      rightContent={
        deleted_at ? (
          <ArchivedItemAction id={id} mutation={useRestoreReportMutation} />
        ) : (
          <div className="flex gap-6 items-center">
            {report.status === ReportStatus.Completed ? (
              <a href={url} target="_blank" rel="noreferrer">
                <img src={DownloadGreyIcon} className="cursor-pointer" alt="Download" />
              </a>
            ) : report.status === ReportStatus.Generating ? (
              <Spinner size="sm" />
            ) : report.status === ReportStatus.Failed ? (
              <TooltipNew text="Report generation failed">
                <img src={AlertOrangeIcon} className="w-6 h-6" alt="alert" />
              </TooltipNew>
            ) : null}

            <img
              src={TrashGrayIcon}
              className={classNames({ 'cursor-pointer': !isReportDeletion })}
              alt="Delete"
              onClick={isReportDeletion ? undefined : handleDeleteReport.bind(null, id)}
            />
          </div>
        )
      }
    />
  );
};

export default ReportItem;
